module.exports = __webpack_public_path__ + "static/media/talking (1).6fdccf97.svg";